import React from 'react';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.5, ease: 'easeOut', delay },
});

export default function HybridModel() {
  const { t } = useLanguage();
  const h = t.hybrid;

  return (
    <section className="py-14 md:py-20 bg-[#1A222B]" data-testid="hybrid-section">
      <div className="section-container">
        <motion.div className="text-center mb-12" {...fadeUp()}>
          <div className="divider-gold mx-auto" />
          <h2 className="heading-lg mb-4">{h.title}</h2>
          <p className="text-[#8A9099] text-base max-w-2xl mx-auto">{h.body}</p>
        </motion.div>

        <motion.div className="overflow-x-auto rounded-2xl border border-[#0F6B49]/30" {...fadeUp(0.1)}>
          <table className="w-full" data-testid="hybrid-table">
            <thead>
              <tr className="bg-[#0F6B49]/20 border-b border-[#0F6B49]/30">
                {[h.colModality, h.colHow, h.colBenefit].map((col, i) => (
                  <th key={i} className="text-left px-6 py-4 text-[#D5A63B] font-exo font-bold italic text-sm uppercase tracking-wider">
                    {col}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {h.rows.map((row, i) => (
                <tr key={i} className={`border-b border-[#0F6B49]/15 last:border-0
                  ${i % 2 === 0 ? 'bg-[#171E26]' : 'bg-[#1a2535]'}
                  hover:bg-[#0F6B49]/10 transition-colors`}
                  data-testid={`hybrid-row-${i}`}>
                  <td className="px-6 py-4">
                    <span className="bg-[#D5A63B]/15 text-[#D5A63B] text-xs font-bold px-3 py-1 rounded-full border border-[#D5A63B]/25">
                      {row.modality}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-[#F3F1EB] text-sm">{row.how}</td>
                  <td className="px-6 py-4 text-[#8A9099] text-sm">{row.benefit}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </motion.div>

        {/* Note */}
        <motion.div className="mt-6 flex items-start gap-3 bg-[#0F6B49]/10 border border-[#0F6B49]/25 rounded-xl p-4"
          {...fadeUp(0.2)}>
          <Shield size={18} className="text-[#D5A63B] flex-shrink-0 mt-0.5" />
          <p className="text-[#8A9099] text-sm">{h.note}</p>
        </motion.div>
      </div>
    </section>
  );
}
